import {CommonModule} from '@angular/common';
import {Component, EventEmitter, input, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {SeFeAlertModule} from 'se-fe-alert';
import {SeFeButtonModule} from 'se-fe-button';
import {SeFeCardModule} from 'se-fe-card';
import {SeFeFormFieldModule} from 'se-fe-form-field';
import {SeFeFormFieldTextModule} from 'se-fe-form-field-text';
import {SeFeFormServiceModule} from 'se-fe-form-service';
import {SeFeGridModule} from 'se-fe-grid';
import {SeFeIconModule} from 'se-fe-icon';
import {SeFeModalComponent, SeFeModalModule} from 'se-fe-modal';
import {SeFeSpinnerModule} from 'se-fe-spinner';
import {SeFeWysiwygModule} from 'se-fe-wysiwyg';
import {Bundle} from '@sportngin/se-commerce-sdk/models/clare';
import {BundleDetailsModalComponent} from './bundle-details-modal/bundle-details-modal.component';
import {UpdateProductDetail} from '../../../../../product/components/product-detail/product-detail.store';

@Component({
  selector: 'bundle-details-card',
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeModalModule,
    BundleDetailsModalComponent,
    SeFeGridModule,
    SeFeFormFieldModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeFormServiceModule,
    SeFeGridModule,
    SeFeIconModule,
    SeFeSpinnerModule,
    SeFeWysiwygModule,
  ],
  templateUrl: './bundle-details-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bundle-details-card.component.scss',
})
export class BundleDetailsCardComponent implements OnInit {
  @Input() error: string | null;
  bundle = input<Bundle>();

  @Output() updateProductAndPriceBreak = new EventEmitter<UpdateProductDetail<{bundle: Partial<Bundle>}>>();

  @ViewChild('detailModal') detailModal: SeFeModalComponent;

  productNameLabel = {label: 'Name'};
  productDescriptionLabel = {label: 'Description'};

  productDescription: string;

  ngOnInit(): void {
    this.productDescription = this.getProductDescription();
  }

  updateBundle(event: UpdateProductDetail<{bundle: Partial<Bundle>}>): void {
    this.updateProductAndPriceBreak.emit(event);
  }

  isBundle(): boolean {
    return true;
  }

  /**
   * Fixes an issue where the description was not wrapping correctly in the modal
   */
  getProductDescription(): string {
    return (
      this.bundle()
        ?.description?.replace(/\u00A0/g, ' ')
        .replace(/&nbsp;/g, ' ') ?? ''
    );
  }
}
